module.exports = __webpack_public_path__ + "media/images/1200/insomnia_moon_dark_skies-a9dec15e034a7a072d3a1716f81efabc.webp";